import { render, staticRenderFns } from "./Tab1.vue?vue&type=template&id=1deed57e&scoped=true"
import script from "./Tab1.vue?vue&type=script&lang=js"
export * from "./Tab1.vue?vue&type=script&lang=js"
import style0 from "./Tab1.vue?vue&type=style&index=0&id=1deed57e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deed57e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1deed57e')) {
      api.createRecord('1deed57e', component.options)
    } else {
      api.reload('1deed57e', component.options)
    }
    module.hot.accept("./Tab1.vue?vue&type=template&id=1deed57e&scoped=true", function () {
      api.rerender('1deed57e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/evaluators/components/Tab1.vue"
export default component.exports